import type { ReactElement } from 'react';
import { AppHeader } from '../components/layout/AppHeader';
import { UserMenu } from '../components/layout/UserMenu';
import { AdminNav } from '../components/navigation/AdminNav';
import { canOpenAdminModule } from '../domain/formatters';
import type { LoginResponse } from '../domain/types';
import { AdminPage } from './AdminPage';

type AuthFetch = (url: string, init?: RequestInit) => Promise<Response>;

interface AdminModulePageProps {
  auth: LoginResponse;
  onLogout: () => void | Promise<void>;
  authFetch: AuthFetch;
}

export function AdminModulePage({ auth, onLogout, authFetch }: AdminModulePageProps): ReactElement {
  return (
    <div className="page page-authed">
      <AppHeader
        navSlot={<AdminNav />}
        endSlot={<UserMenu auth={auth} onLogout={onLogout} />}
      />
      <div className="app-content">
        {canOpenAdminModule(auth.role) ? (
          <AdminPage authFetch={authFetch} />
        ) : (
          <p className="error" data-testid="admin-denied">
            You do not have permission to open the Admin module.
          </p>
        )}
      </div>
    </div>
  );
}
